import React from 'react';

export const Cron = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7791 5.19588C11.8893 4.62312 10.83 4.29083 9.69317 4.29083C6.54008 4.29083 3.98401 6.84691 3.98401 9.99999C3.98401 13.1531 6.54008 15.7092 9.69317 15.7092C10.7261 15.7092 11.695 15.4348 12.5309 14.9551L15.0815 17.5057C13.5648 18.5965 11.704 19.2389 9.69317 19.2389C4.59064 19.2389 0.454224 15.1025 0.454224 9.99999C0.454224 4.89746 4.59064 0.761047 9.69317 0.761047C11.8064 0.761047 13.754 1.47057 15.3106 2.66438L12.7791 5.19588Z"
      fill="white"
    />
    <path
      d="M17.6556 5.31123L15.0215 7.94539C15.2675 8.58293 15.4023 9.27571 15.4023 9.99999C15.4023 10.8324 15.2242 11.6232 14.904 12.3363L17.5041 14.9365C18.4085 13.5084 18.9321 11.8154 18.9321 9.99999C18.9321 8.2885 18.4667 6.6857 17.6556 5.31123Z"
      fill="white"
    />
  </svg>
);
